<app-table
  [cols]="colsCob"
  [lazy]="false"
  [expansionLazy]="false"
  [elements]="cobrancas"
  modelName="cobranças"
  tableTitle=" "
  [addButton]="false"
  [defaultFilterValues]="defaultFilters"
  [dropdownFilters]="dropdownFiltersCob"
  sortField="calendario.criacao"
  [sortOrder]="1"
  [actionButtons]="buttons"
  *ngIf="cobrancas"
  (changedFilter)="
    $event.field === 'calendario.criacao' && findCobrancas($event.value)
  "
  [expansionCols]="attemptCols"
  dataKey="txid"
  expandField="tentativas"
  [expandPaginator]="false"
/>
<p-toast />
<p-confirmPopup />
